export const MICGRO_BACKUP_APP = 'MicGro Manager';
export const MICGRO_BACKUP_VERSION = 1;

export const createBackupMetadataFile = () => ({
  filename: 'metadata.json',
  data: new TextEncoder().encode(JSON.stringify({
    app: MICGRO_BACKUP_APP,
    version: MICGRO_BACKUP_VERSION,
    created: new Date().toISOString(),
  }, null, 2)),
});

export const validateBackupMetadata = (files) => {
  const metadataFiles = files.filter(
    (file) => file.filename.toLowerCase() === 'metadata.json'
  );

  if (metadataFiles.length === 0) {
    return { legacy: true, metadata: null };
  }
  if (metadataFiles.length > 1) {
    throw new Error('This backup contains duplicate metadata files.');
  }

  let metadata;
  try {
    metadata = JSON.parse(new TextDecoder().decode(metadataFiles[0].data));
  } catch {
    throw new Error('This backup contains invalid metadata.');
  }

  if (metadata?.app !== MICGRO_BACKUP_APP) {
    throw new Error('This file is not a valid MicGro Manager backup.');
  }
  if (metadata?.version !== MICGRO_BACKUP_VERSION) {
    throw new Error(
      `This backup uses unsupported format version ${String(metadata?.version ?? 'unknown')}.`
    );
  }
  if (typeof metadata?.created !== 'string' || Number.isNaN(Date.parse(metadata.created))) {
    throw new Error('This backup contains an invalid creation date.');
  }

  return { legacy: false, metadata };
};
